import moment from "moment-timezone";

export function createGoogleCalendarEvent(data) {
  const eventDetails = `
  【LiteFreshVoice】WEB会議

  ■会議名
  ${data.fvroom_name}

  ■役割
  ${data.isWebinar ? '講師' : 'ホスト'}

  ■招待URL
  すぐに参加する場合はこちらのリンクをクリックしてください。
  ${data.url}

  ■推奨ブラウザ
  ・Windows：GoogleChrome、Microsoft Edge
  ・Mac：GoogleChrome
  ・iOS(iPhone・iPad)：Google Chrome
  ・Android OS：Google Chrome
  `;

  let URL = makeGCalLink(data.url, eventDetails);
  if(data.has_expiration) {
    const startDate = moment(data.expiration_start_date).tz(data.timezone).format('YYYYMMDDTHHmmss');
    const endDate = moment(data.expiration_end_date).tz(data.timezone).format('YYYYMMDDTHHmmss');
    URL += `&dates=${startDate}Z/${endDate}Z&ctz=${data.timezone}`;
  }
  window.open(URL)
}

function makeGCalLink(location, details) {
  let link;
  link = 'http://www.google.com/calendar/event?action=TEMPLATE';
  link += '&location=' + encodeURIComponent( location );
  link += '&details=' + encodeURIComponent( details );
  return link;
}


// WEBPACK FOOTER //
// src/lib/googleCalendar.js